import { render, staticRenderFns } from "./CollectionOfficerStat.vue?vue&type=template&id=40f17202&scoped=true"
import script from "./CollectionOfficerStat.vue?vue&type=script&lang=js"
export * from "./CollectionOfficerStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f17202",
  null
  
)

export default component.exports